// core
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

// constants
import {AppConstants} from "../utils/constants";

// services
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-confirmation-page',
    templateUrl: './confirmation-page.component.html',
    styleUrls: ['./confirmation-page.component.scss'],
    standalone: false
})
export class ConfirmationPageComponent implements OnInit {

  private forgotPassword: boolean;
  private registrationForm: boolean;
  private newsletterSubscription: boolean;

  private usersLanguage: string;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _translateService: TranslateService
  ) {
  }

  ngOnInit() {
    this._activatedRoute
      .queryParams
      .subscribe(params => {
        this.pageToBoolean(params['origin']);
        this.usersLanguage = params['language'];

        if (this.usersLanguage) {
          this._translateService.setDefaultLang(this.usersLanguage);
          this._translateService.use(this.usersLanguage);
        }

      });
  }

  public getForgotPassword() {
    return this.forgotPassword;
  }

  public getRegistrationForm() {
    return this.registrationForm;
  }

  public getNewsletterSubscription() {
    return this.newsletterSubscription;
  }


  private pageToBoolean(val) {
    this.forgotPassword = val === AppConstants.forgotPassword;
    this.registrationForm = val === AppConstants.userRegistrationPath;
    this.newsletterSubscription = val === AppConstants.newsletterAgreement;
  }

}
